import { React, useEffect, useState } from "react";
import { Button, Form, Input, Col, Row, DatePicker, Tooltip } from "antd";
import {
  HaberForm,
  RightDrawerContainer,
  DetailFields,
} from "../../styledElements";
import alertRed from "../../../Assets/Icons/alertRed.svg";
import RightDrawerSidebar from "../../../Components/RightDrawer/rightDrawer";

import AlertContainer from "../../../Components/AlertBoxes/alertBox";
import Iconmoon from "../../../Components/IconsFiles/icon";
import { Switch } from "antd";
import { DatePickerY, GlobalSet, Styled } from "../../pageStyled";
import {
  getExchangeRateData,
  updateExchangeRateData,
  updateSystemExchangeRate,
} from "../../../Services/measurementService";
import moment from "moment/moment";

const ExchangeRateDrawer = (props) => {
  const [form] = Form.useForm();

  const [error, setError] = useState(false);
  const [exchangeRateData, setExchangeRateData] = useState();
  const [currencyRate, setCurrencyRate] = useState();
  const userDetails = JSON.parse(localStorage.getItem("user-details"));

  useEffect(() => {
    getExchangeRateData().then((response) => {
      let currency = [];
      let data = response;
      for (let index = 0; index < data.data.exchange_data.length; index++) {
        data.data.exchange_data[index]["action"] = "view";
        currency.push(data.data.exchange_data[index].active_exchange_rate);
      }
      setCurrencyRate(currency);
      setExchangeRateData({ ...data });
    });
  }, []);

  const onActionChange = (index, action, currency) => {
    let data = { ...exchangeRateData };
    if (action === "view") {
      form.resetFields();
      form.setFieldsValue({
        [`date${index}`]: exchangeRateData.data.exchange_data[index].date
          ? moment(
              moment(exchangeRateData.data.exchange_data[index].date).format(
                "DD MM YYYY"
              ),
              "DD MM YYYY"
            )
          : moment(moment(new Date()).format("DD MM YYYY"), "DD MM YYYY"),
        [`currency${index}`]:
          exchangeRateData.data.exchange_data[index].currency,
        [`active_exchange_rate${index}`]: exchangeRateData.data.exchange_data[
          index
        ].active_exchange_rate
          ? exchangeRateData.data.exchange_data[index].active_exchange_rate
          : "",
      });
      data.data.exchange_data[index].action = "view";
      setExchangeRateData({ ...data });
      let currency = [...currencyRate];
      currency[index] =
        exchangeRateData.data.exchange_data[index].active_exchange_rate;
      setCurrencyRate(currency);
    }

    if (action === "edit") {
      data.data.exchange_data[index].action = "edit";
      setExchangeRateData({ ...data });
    }

    if (action === "save") {
      if(!(form.getFieldError(`active_exchange_rate${index}`)).length)
      {
      let req = {
        currency: form.getFieldValue(`currency${index}`),
        active_exchange_rate: parseFloat( form.getFieldValue(
          `active_exchange_rate${index}`
        )),
        date: moment(form.getFieldValue(`date${index}`)).format("YYYY-MM-DD"),
      };
      updateExchangeRateData(req, currency.id)
        .then((response) => {
          data.data.exchange_data[index].currency = form.getFieldValue(
            `currency${index}`
          );
          data.data.exchange_data[index].active_exchange_rate =
            form.getFieldValue(`active_exchange_rate${index}`);
          data.data.exchange_data[index].date = moment(
            form.getFieldValue(`date${index}`)
          ).format("YYYY-MM-DD");
          data.data.exchange_data[index].action = "view";
          setExchangeRateData({ ...data });
        })
        .catch((error) => console.log(error));
    }
  }
  };

  const onCurrencyRateChange = (e, index) => {
    let currency = [...currencyRate];
    currency[index] = e.target.value;
    setCurrencyRate(currency);
  };

  const onClickHistory = () => {
    props.onClickHistory();
  };

  const handleSwitchChange = (e) => {
    const filterData = exchangeRateData.data.exchange_data.filter(
      (data) => data.active_exchange_rate == 0
    );
    if (filterData.length && !e) {
      setError(true);
      setTimeout(() => {
        setError(false);
      }, 3000);
    } else {
      let req = {
        system_exchange_rates: e,
      };
      updateSystemExchangeRate(req)
        .then((response) => {
          let data = {...exchangeRateData};
          data.data.system_exchange_rates = e;
          setExchangeRateData({...data});
        })
        .catch((error) => console.log(error));
    }
  };

  return exchangeRateData ? (
    <RightDrawerSidebar
      title={!error ? "Exchange Rates" : `\b`}
      subtitle={
        !error
          ? `Default Currency: ${exchangeRateData.data.default_currency}`
          : `\b`
      }
      visible={props.visible}
      onClose={() => {
        setExchangeRateData("");
        props.onClose();
      }}
    >
      {error && (
        <AlertContainer
          color="red toaster"
          icon={alertRed}
          closeIcon={true}
          setClose={setError}
          msg={
            "You can switch to manual conversion <br>only if you have defined the conversion<br> rates below"
          }
        />
      )}
      <RightDrawerContainer>
        <div className="resetPassForm removePadLeft">
         
            <DetailFields className="marginBtnP">
              <HaberForm>
                <Form
                  name="basic"
                  autoComplete="off"
                  className="haberLogin haberSignup"
                  style={{ marginTop: "0" }}
                  form={form}
                >
                  <div className="drawerField">
                    <Row className="centerAlign justifyCSBetween">
                      <Col span={20}>
                        <div
                          className="boxFieldTitle"
                          style={{ paddingLeft: "0px" }}
                        >
                          <label>Use System defined exchange rates</label>
                          <p>
                            If enabled, the system will automatically determine
                            the valid exchange rate for a particular date. If
                            disabled, the system will use the exchange rate
                            manually entered by the user.
                          </p>
                        </div>
                      </Col>
                      <Col span={4}>
                        <div className="boxFormType">
                          <GlobalSet>
                            <Styled>
                              <Switch
                                // ref={toggleRef}
                                checked={exchangeRateData.data.system_exchange_rates}
                                onChange={(e) => handleSwitchChange(e)}
                                className="switch-new"
                                disabled = {!userDetails.roles.advanced_settings.edit}
                              />
                            </Styled>
                          </GlobalSet>
                        </div>
                      </Col>
                    </Row>
                  </div>
                  <div
                    className="boxFieldTitle"
                    style={{
                      paddingLeft: "0px",
                      paddingBottom: "20px",
                      paddingTop: "20px",
                    }}
                  >
                    <label>Manual Exchange Rates</label>
                  </div>

                  <Row className="centerAlign justifyCSBetween">
                    <Col span={5} style={{ paddingRight: "5px" }}>
                      <div
                        className="boxFormType"
                        style={{ marginBottom: "0" }}
                      >
                        <p>Currency</p>
                      </div>
                    </Col>

                    <Col span={6} style={{ paddingRight: "5px" }}>
                      <div
                        className="boxFormType"
                        style={{ marginBottom: "0" }}
                      >
                        <p>Exchange Rate</p>
                      </div>
                    </Col>

                    <Col span={9}>
                      <div
                        className="boxFormType"
                        style={{ marginBottom: "0" }}
                      >
                        <p>Date</p>
                      </div>
                    </Col>
                    <Col
                      span={4}
                      style={{ paddingLeft: "8px", marginTop: "10px" }}
                    >
                      <div
                        className="boxFormType"
                        style={{ marginBottom: "0" }}
                      ></div>
                    </Col>
                  </Row>
                  {exchangeRateData.data.exchange_data.map((data, index) => {
                    return (
                      <Row className="centerAlign justifyCSBetween">
                        <Col span={5} style={{ paddingRight: "5px" }}>
                          <div
                            className="boxFormType"
                            style={{ marginBottom: "0" }}
                          >
                            <Form.Item
                              name={`currency${index}`}
                              rules={[{ required: true }]}
                              initialValue={data.currency}
                              className="dBlock"
                              style={{ marginBottom: "5px" }}
                            >
                              <Input disabled />
                            </Form.Item>
                          </div>
                        </Col>

                        <Col span={6} style={{ paddingRight: "5px" }}>
                          <div
                            className="boxFormType"
                            style={{ marginBottom: "0" }}
                          >
                            <Form.Item
                              name={`active_exchange_rate${index}`}
                              rules={[
                                {
                                  required: true,
                                  message: "This is a required field",
                                },
                                {
                                  pattern: new RegExp(
                                    /^\s*(?:0*[1-9]\d*)(?:\.\d{1,3})?\s*$/
                                  ),
                                  message:
                                    "Non zero numeric value upto three decimal places allowed",
                                },
                                // {
                                //   pattern: new RegExp(/^[1-9]\d*$/),
                                //   message: " Conversion rate should be a non zero value",
                                // },
                              ]}
                              initialValue={
                                data.active_exchange_rate
                                  ? data.active_exchange_rate
                                  : ""
                              }
                              className="dBlock"
                              style={{ marginBottom: "5px" }}
                            >
                              <Input
                                disabled={data.action === "view"}
                                onChange={(e) => onCurrencyRateChange(e, index)}
                              />
                            </Form.Item>
                          </div>
                        </Col>

                        <Col span={9} style={{ paddingRight: "3px" }}>
                          <div
                            className="boxFormType"
                            style={{ marginBottom: "0" }}
                          >
                            <DatePickerY>
                              <Form.Item
                                name={`date${index}`}
                                rules={[{ required: true }]}
                                initialValue={
                                  data.date
                                    ? moment(
                                        moment(data.date).format("DD MM YYYY"),
                                        "DD MM YYYY"
                                      )
                                    : moment(
                                        moment(new Date()).format("DD MM YYYY"),
                                        "DD MM YYYY"
                                      )
                                }
                                className="dBlock"
                                style={{ marginBottom: "5px" }}
                              >
                                <DatePicker
                                  disabled={data.action === "view"}
                                  format={"DD/MM/YYYY"}
                                  // Cannot select days before today for delivery date
                                />
                              </Form.Item>
                            </DatePickerY>
                          </div>
                        </Col>
                        <Col span={4}>
                          <div
                            className="boxFormType"
                            style={{ marginBottom: "0", paddingLeft: "9px" }}
                          >
                            {data.action === "edit" && (
                              <Tooltip
                              title={"Save conversion rate"}
                              >
                              <Button
                                key="3"
                                className=" edit-btn"
                                style={{
                                  padding: "0px",
                                  margin: "0px",
                                  width: "28px",
                                  border: "none",
                                }}
                                onClick={() =>
                                  onActionChange(index, "save", data)
                                }
                              >
                                <Iconmoon
                                  icon="check"
                                  size={23}
                                  color="#3FBD61"
                                />
                              </Button>
                              </Tooltip>
                            )}
                            {data.action === "view" && (
                              <Tooltip
                              title={"Allow editing the input fields"}
                              >
                              <Button
                              disabled = {!userDetails.roles.advanced_settings.edit}
                                key="1"
                                className="edit-btn"
                                style={{
                                  padding: "0px",
                                  margin: "0px",
                                  width: "28px",
                                  border: "none",
                                }}
                                onClick={() =>
                                  onActionChange(index, "edit", data)
                                }
                              >
                                <Iconmoon
                                  icon="edit"
                                  size={18}
                                  color="#000000"
                                />
                              </Button>
                              </Tooltip>
                            )}
                            {data.action === "edit" && (
                              <Tooltip
                              title={"Cancel Changes"}
                              >
                              <Button
                                key="2"
                                className=" edit-btn"
                                style={{
                                  padding: "0px",
                                  margin: "0px",
                                  width: "20px",
                                  border: "none",
                                }}
                                onClick={() =>
                                  onActionChange(index, "view", data)
                                }
                              >
                                <Iconmoon icon="cancel" size={23} color="red" />
                              </Button>
                              </Tooltip>
                            )}
                          </div>
                        </Col>
                        {(data.active_exchange_rate != 0 ||
                          data.active_exchange_rate != "") && (
                          <p style={{ fontSize: "10px" }}>
                            1 {data.currency} = {currencyRate[index]}{" "}
                            {exchangeRateData.data.default_currency}
                          </p>
                        )}
                      </Row>
                    );
                  })}
                  <div
                    className="buttonFlex fixedBtm"
                    style={{ flexDirection: "row" }}
                  >
                    <Button
                      key="1"
                      className="themeBtn noBg"
                      // disabled={!roles.edit_own}
                      onClick={onClickHistory}
                    >
                      <Iconmoon icon="history" size={16} color="#EA655B" />
                      View Historical Rates
                    </Button>
                  </div>
                </Form>
              </HaberForm>
            </DetailFields>
         
        </div>
      </RightDrawerContainer>
    </RightDrawerSidebar>
  ) : null;
};

export default ExchangeRateDrawer;
